<template>
  <div class="scene-my-rewards">
    <div class="back-button" @click="onBack">
      <img src="/images/game/back.png" />
    </div>

    <div class="tips">
      <img class="sprite" src="/images/game/sprite-8.png" alt />
      <span class="tip1">小悦提示：</span>
      <span class="tip2">礼品需要通过发送核销码链接短信至手机，点开链接展示核销码给门店店员换取相应礼品！</span>
    </div>

    <ScrollableContainer class="rewards-parent" :width="790" :height="500">
      <div class="rewards" :style="`transform: translateY(${y}px)`">
        <div class="reward" v-for="(item, index) in rewardList" :key="index">
          <img class="card" :src="item.card" />

          <div class="desc">
            <div class="title">{{item.desc}}</div>
            <span class="name">{{item.name}}</span>
            <span class="count">x{{item.count}}</span>
          </div>
          <div class="used" v-if="item.used">礼品已核销</div>
          <div class="send" v-else>
            <div class="button" @click="onSend(item)">发送核销码至手机</div>
            <div class="text" v-if="item.send">核销码已发送，请注意查收</div>
          </div>
        </div>
      </div>
    </ScrollableContainer>
  </div>
</template>

<script>
import ScrollableContainer from "../common/ScrollableContainer";

export default {
  name: "MyRewardsScene",
  components: {
    ScrollableContainer
  },
  data() {
    return {
      y: 0,
      rewardList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;

      response = await this.ajax.doPost({
        packageName: "game",
        className: "common",
        methodName: "getMyRewards",
        params: {}
      });
      this.rewardList = response.map(e => {
        return {
          ...e,
          send: false
        };
      });
    },
    async onSend(item) {


      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");

      let response;

      response = await this.ajax.doPost({
        packageName: "game",
        className: "common",
        methodName: "sendCode",
        params: {
          resId: item.id
        }
      });

      console.log(response)

      item.send = true;
    },
    onBack() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "MainScene");
    }
  }
};
</script>


<style lang="scss" scoped>
.scene-my-rewards {
  width: 1100px;
  height: 560px;
  position: relative;

  background: linear-gradient(
    180deg,
    rgba(96, 66, 11, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );

  .back-button {
    position: absolute;
    width: 80px;
    height: 40px;
    cursor: pointer;

    img {
      width: 100%;
    }

    img:hover {
      box-shadow: 0px 2px 27px 7px rgba(250, 100, 0, 0.43);
    }
  }

  .tips {
    width: 1100px;
    height: 60px;
    line-height: 60px;
    background: rgba(33, 33, 33, 1);
    text-align: center;

    .sprite {
      vertical-align: top;
      margin-top: 7px;
      width: 72px;
      height: 53px;
      transform: rotateY(180deg);
    }

    .tip1 {
      vertical-align: top;
      margin: 21px 10px;
      font-size: 18px;
      font-family: "FZFMJW";
      font-weight: normal;
      color: rgba(147, 147, 147, 1);
    }

    .tip2 {
      vertical-align: top;
      margin: 23px 0;
      font-size: 14px;
      font-weight: 400;
      color: rgba(147, 147, 147, 1);
    }
  }

  .rewards-parent {
    width: 790px;
    height: 500px;
    overflow: hidden;
    margin: 0 auto;
  }

  .rewards {
    width: 790px;
    margin: 0 auto;
    padding: 5px 0;
    .reward {
      margin: 10px 0;
      width: 690px;
      padding: 8px 50px;
      height: 110px;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.49) 49%,
        rgba(0, 0, 0, 0) 100%
      );
      //   opacity: 0.6988;

      .card {
        vertical-align: top;
        height: 110px;
      }
      .desc {
        vertical-align: top;
        display: inline-block;
        width: 345px;
        .title {
          margin: 20px;
          height: 28px;
          font-size: 24px;
          font-family: "FZFMJW";
          font-weight: normal;
          color: rgba(228, 200, 150, 1);
          line-height: 28px;
        }

        .name {
          margin: 20px 0 0 20px;
          height: 22px;
          font-size: 16px;

          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 22px;

          color: white;
        }

        .count {
          margin-left: 20px;
          height: 22px;
          font-size: 16px;

          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 22px;

          color: #e4c896;
        }
      }
      .send {
        vertical-align: top;
        display: inline-block;

        .button {
          margin-top: 35px;
          text-align: center;
          cursor: pointer;
          width: 141px;
          height: 36px;
          background: linear-gradient(
            270deg,
            rgba(255, 255, 255, 1) 0%,
            rgba(222, 214, 192, 1) 100%
          );
          border: 2px solid rgba(255, 255, 255, 0.19);

          font-size: 14px;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          line-height: 36px;
        }

        .text {
          margin-top: 10px;
          width: 144px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(155, 155, 155, 1);
        }
      }

      .used {
        vertical-align: top;
        display: inline-block;

        margin-top: 45px;
        text-align: center;
        width: 141px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(228, 200, 150, 1);
      }
    }
  }
}
</style>